import { fr as authentication } from './authentication'
import { fr as commonBackgroundCheck } from './common/background-check'
import { fr as common } from './common/base'
import { fr as commonBaseListing } from './common/base-listing'
import { fr as commonBooking } from './common/booking'
import { fr as commonComponents } from './common/components'
import { fr as commonInvestmentAssumption } from './common/investment-assumption'
import { fr as commonPayment } from './common/payment'
import { fr as commonPayout } from './common/payout'
import { fr as commonPropRental } from './common/prop-rental'
import { fr as commonPropertySale } from './common/property-sale'
import { fr as commonPropSharing } from './common/propsharing'
import { fr as commonRealEstate } from './common/real-estate'
import { fr as commonRentPayment } from './common/rent-payment'
import { fr as commonRentalListing } from './common/rental-listing'
import { fr as commonTask } from './common/task'
import { fr as commonTenantPreference } from './common/tenant-preference'
import { fr as errors } from './errors'
import { fr as listing } from './listing'
import { fr as mainAccount } from './main/account'
import { fr as mainBackgroundCheck } from './main/background-check'
import { fr as mainBlog } from './main/blog'
import { fr as mainBooking } from './main/booking'
import { fr as mainBookingApplicant } from './main/booking-applicant'
import { fr as mainBookingDocument } from './main/booking-document'
import { fr as mainBookingRentPayment } from './main/booking-rent-payment'
import { fr as mainInvestments } from './main/investments'
import { fr as mainMyInvestments } from './main/my-investments'
import { fr as mainNotification } from './main/notification'
import { fr as mainPayment } from './main/payment'
import { fr as mainPayout } from './main/payout'
import { fr as mainPropertySale } from './main/property-sale'
import { fr as mainPropSharing } from './main/propsharing'
import { fr as mainRentalListing } from './main/rental-listing'
import { fr as mainRentalListingInquiry } from './main/rental-listing-inquiry'
import { fr as mainStatistic } from './main/statistic'
import { fr as mainTenantApplication } from './main/tenant-application'
import { fr as mainTenantPreference } from './main/tenant-preference'
import { fr as mainWebapp } from './main/webapp'
import { fr as officeBooking } from './office/booking'
import { fr as officeLeaseContract } from './office/lease-contract'
import { fr as officeNote } from './office/note'
import { fr as officePayment } from './office/payment'
import { fr as officePayout } from './office/payout'
import { fr as officePropertySale } from './office/property-sale'
import { fr as officePropSharing } from './office/propsharing'
import { fr as officeRealEstate } from './office/real-estate'
import { fr as officeRentPayment } from './office/rent-payment'
import { fr as officeRentalListing } from './office/rental-listing'
import { fr as officeRentalListingCreation } from './office/rental-listing-creation'
import { fr as officeRentalListingInquiry } from './office/rental-listing-inquiry'
import { fr as officeRentalListingLeadListing } from './office/rental-listing-lead-listing'
import { fr as officeSearch } from './office/search'
import { fr as officeUser } from './office/user'
import { fr as officeWebapp } from './office/webapp'
import { fr as payout } from './payout'

export const fr = {
  authentication,
  errors,
  common,
  listing,
  payout,
  'common-backgroundCheck': commonBackgroundCheck,
  'common-baseListing': commonBaseListing,
  'common-booking': commonBooking,
  'common-components': commonComponents,
  'common-investmentAssumption': commonInvestmentAssumption,
  'common-rentalListing': commonRentalListing,
  'common-propertySale': commonPropertySale,
  'common-propsharing': commonPropSharing,
  'common-payment': commonPayment,
  'common-payout': commonPayout,
  'common-propRental': commonPropRental,
  'common-realEstate': commonRealEstate,
  'common-rentPayment': commonRentPayment,
  'common-task': commonTask,
  'common-tenantPreference': commonTenantPreference,
  'main-account': mainAccount,
  'main-backgroundCheck': mainBackgroundCheck,
  'main-blog': mainBlog,
  'main-booking': mainBooking,
  'main-bookingApplicant': mainBookingApplicant,
  'main-bookingDocument': mainBookingDocument,
  'main-bookingRentPayment': mainBookingRentPayment,
  'main-propsharing': mainPropSharing,
  'main-investments': mainInvestments,
  'main-myInvestments': mainMyInvestments,
  'main-notification': mainNotification,
  'main-payment': mainPayment,
  'main-payout': mainPayout,
  'main-propertySale': mainPropertySale,
  'main-rentalListing': mainRentalListing,
  'main-rentalListingInquiry': mainRentalListingInquiry,
  'main-statistic': mainStatistic,
  'main-tenantApplication': mainTenantApplication,
  'main-tenantPreference': mainTenantPreference,
  webapp: mainWebapp,
  'main-webapp': mainWebapp,
  'office-booking': officeBooking,
  'office-propsharing': officePropSharing,
  'office-leaseContract': officeLeaseContract,
  'office-propertySale': officePropertySale,
  'office-rentalListing': officeRentalListing,
  'office-rentalListingCreation': officeRentalListingCreation,
  'office-rentalListingInquiry': officeRentalListingInquiry,
  'office-rentalListingLeadListing': officeRentalListingLeadListing,
  'office-note': officeNote,
  'office-payout': officePayout,
  'office-payment': officePayment,
  'office-realEstate': officeRealEstate,
  'office-rentPayment': officeRentPayment,
  'office-search': officeSearch,
  'office-user': officeUser,
  'office-webapp': officeWebapp,
}
